/* src/app/components/billing/patient-ledger/view-patient-ledger/view-patient-ledger.component.css */
/*# sourceMappingURL=view-patient-ledger.component-I7NMTAEK.css.map */
